export function parseCsvRow(line: string): string[] {
  const records = parseCsvRecords(line);
  return records[0] ?? [''];
}

export function parseCsvRecords(text: string): string[][] {
  const rows: string[][] = [];
  let current: string[] = [];
  let field = '';
  let inQuotes = false;
  let fieldWasQuoted = false;
  let hadAnyChar = false;

  const pushField = () => {
    current.push(fieldWasQuoted ? field : field.trim());
    field = '';
    fieldWasQuoted = false;
  };

  const finishRow = () => {
    pushField();
    if (current.length > 1 || (current.length === 1 && current[0] !== '')) {
      rows.push(current);
    }
    current = [];
    hadAnyChar = false;
  };

  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (inQuotes) {
      if (ch === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i += 1;
        } else {
          inQuotes = false;
        }
      } else {
        field += ch;
      }
      hadAnyChar = true;
      continue;
    }
    if (ch === '"') {
      inQuotes = true;
      fieldWasQuoted = true;
      hadAnyChar = true;
      continue;
    }
    if (ch === ',') {
      pushField();
      hadAnyChar = true;
      continue;
    }
    if (ch === '\r') {
      if (text[i + 1] === '\n') i += 1;
      finishRow();
      continue;
    }
    if (ch === '\n') {
      finishRow();
      continue;
    }
    field += ch;
    hadAnyChar = true;
  }

  if (hadAnyChar || field !== '' || current.length > 0) {
    finishRow();
  }

  return rows;
}
